/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */

export type ResourceIconID = (typeof ResourceIconID)[keyof typeof ResourceIconID];

export const ResourceIconID = {
  ADMINISTRATION: 'administration',
  CENTER_OR_INITIATIVE: 'center-or-initiative',
  COMMUNITY: 'community',
  EDUCATION: 'education',
  FUNDING_RESOURCE: 'funding-resource',
  HEALTH_SYSTEM: 'health-system',
  INFO_OR_ANALYTICS: 'info-or-analytics',
  INFORMATION: 'information',
  OTHER_FACILITY: 'other-facility',
  REGULATORY_AND_COMPLIANCE: 'regulatory-and-compliance',
  RESEARCH_CORES_AND_LABS: 'research-cores-and-labs',
  RESEARCH_FACILITY: 'research-facility',
  RESEARCH_RESOURCE: 'research-resource',
} as const;
